// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2KHA9","title":"AfterFrontImage_title__jCQ_H"};